import request from '@/utils/request'
// 上传文件
export const uploadFile = data => {
  return request.post('/webapi/common/uploadFile', data)
}
// 新上传文件
export const uploadNewFile = data => {
  return request.post('/webapi/common/uploadnewFile', data)
}
// 发送验证码
export const sendsmsCode = data => {
  return request.post('/webapi/sendsmsCode', data)
}

// 企业性质下拉列表
export const natureList = () => {
  return request.get('/webapi/common/getNatureList')
}

// 获取当前客户下面所有配置的商户号
export const getMchList = (params) => {
  return request.get('/webapi/mch/getCompanyMchList', { params })
}

// appId下拉列表
export const getappIDList = () => {
  return request.get('/webapi/appId/list')
}

// 消息列表
export const noticeList = (data) => {
  return request.post('/webapi/notice/noticeList', data)
}

// 读取消息
export const noticeRead = (data) => {
  return request.post('/webapi/notice/noticeRead', data)
}

// 全部已读
export const noticeallRead = (params) => {
  return request.post('/webapi/notice/noticeallRead', { params })
}

// 公司下拉框
export const getCompanyList = () => {
  return request.get('/adminapi/common/getCompanyList')
}